import {
    RustIcon,
    PythonIcon,
    TypescriptIcon,
    FastAPIIcon,
    DockerIcon,
    LlmsIcon,
    AwsIcon,
    TerraformIcon,
    PostgresqlIcon,
    KafkaIcon,
    BigQueryIcon,
    SnowflakeIcon,
    TemporalIcon,
    NetSuiteIcon,
    CeligoIcon,
    StripeIcon,
    GoogleAdsIcon,
    MetaIcon,
  } from "./icons";
  import type { Skill } from "./types";

  // Flattened skills data for grid layout
  export const skillsData: Skill[] = [
    // Row 1 - Languages & runtime
    { name: "Rust", icon: <RustIcon className="w-12 h-12" /> },
    { name: "Python", icon: <PythonIcon className="w-12 h-12" /> },
    { name: "TypeScript", icon: <TypescriptIcon className="w-12 h-12" /> },
    { name: "FastAPI", icon: <FastAPIIcon className="w-12 h-12" /> },
    { name: "Docker", icon: <DockerIcon className="w-12 h-12" /> },
    { name: "LLMs", icon: <LlmsIcon className="w-12 h-12" /> },
    // Row 2 - Cloud, data & orchestration
    { name: "AWS", icon: <AwsIcon className="w-12 h-12" /> },
    { name: "Terraform", icon: <TerraformIcon className="w-12 h-12" /> },
    { name: "PostgreSQL", icon: <PostgresqlIcon className="w-12 h-12" /> },
    { name: "Kafka", icon: <KafkaIcon className="w-12 h-12" /> },
    { name: "BigQuery", icon: <BigQueryIcon className="w-12 h-12" /> },
    { name: "Snowflake", icon: <SnowflakeIcon className="w-12 h-12" /> },
    // Row 3 - Orchestration, ERP & revenue
    { name: "Temporal", icon: <TemporalIcon className="w-12 h-12" /> },
    { name: "NetSuite", icon: <NetSuiteIcon className="w-12 h-12" /> },
    { name: "Celigo", icon: <CeligoIcon className="w-12 h-12" /> },
    { name: "Stripe", icon: <StripeIcon className="w-12 h-12" /> },
    { name: "Google Ads", icon: <GoogleAdsIcon className="w-12 h-12" /> },
    { name: "Meta", icon: <MetaIcon className="w-12 h-12" /> },
  ];
